import { StackedLineChart } from '@mui/icons-material';
import { useWidgetState } from 'components/management/customDashboard/CustomWidgetContext';
import type { CustomWidgetDescription } from 'components/management/customDashboard/CustomWidgetDescription.types.ts';
import { calculateDefaultPresetRange } from 'components/management/TilesDateRangeSelector';
import ProfitLossChart from './ProfitLossChart.tsx';
import {
  ProfitLossSettings,
  type ProfitLossSettingsState,
} from 'components/portfolio/profitLoss/overview/ProfitLossSettings.tsx';

export const profitLossWidget: CustomWidgetDescription = {
  name: 'Total P&L',
  type: 'profitLossChart',
  description: 'Time weighted rate of return',
  icon: () => <StackedLineChart />,
  viewComponent: ({ id }) => {
    const initialState = useWidgetState<ProfitLossSettingsState>(id);
    const range = calculateDefaultPresetRange(initialState.predefinedDateRange?.label);
    return <ProfitLossChart {...initialState} dateRange={range.value()} fullHeight />;
  },
  settingsComponent: ProfitLossSettings,
  initialH: 4,
  initialW: 3,
};
